// Notas de crédito: histórico y entrega — SPEC_NOTAS_DE_CREDITO_v0.1.md §8.
//
// OJO con la firma del wrapper (H-J): `apiService.get(url, params)`, con los
// params como SEGUNDO argumento. Escribir `{ params: {...} }` —la forma de
// axios crudo— los anida, el backend no ve ningún filtro y la lista devuelve
// todo sin avisar.
import apiService from '@/services/apiService.js'

const datos = (respuesta) => respuesta?.data?.data ?? null

export async function listarNotasCredito ({ q = '', origen = '', pagina = 1, porPagina = 25 } = {}) {
  const params = { pagina, por_pagina: porPagina }
  if (q && q.trim()) params.q = q.trim()
  if (origen) params.origen = origen
  return datos(await apiService.get('/api/notas-credito', params))
}

export async function obtenerComprobanteNotaCredito (receiptId) {
  return datos(await apiService.get(`/api/notas-credito/${receiptId}/comprobante`))
}

export const ORIGEN_ETIQUETA = Object.freeze({
  ANULACION_COBRO: 'Anulación de cobro',
  DEVOLUCION_MERCADERIA: 'Devolución de mercadería'
})
